<!-- Header -->
<div mat-dialog-title>
    <span translate>Multiple Families</span>
</div>

<!-- Body -->
<div *ngIf="!isUHD && gradeLevelMessage" style="padding-left:10px;padding-top:10px;padding-right:10px;">
  {{gradeLevelMessage | translate}} {{gradeLevelData}}
</div>
<div *ngIf="note" style="padding-left:10px;padding-top:10px;padding-right:10px;">
  {{note | translate}}
</div>
<mat-dialog-content>
  <table class="mat-table">
    <tr class="mat-header-row" style="border-width:0;border-bottom-width: 1px;border-style: solid;align-items: center;box-sizing: border-box;border-bottom-color: rgba(0,0,0,.12);">
      <th class="mat-header-cell" style="width: 60px;">

      </th>
      <th class="mat-header-cell" style="font-size: 14px;width: 180px;">
          <span translate>Your Role</span>
      </th>
      <th class="mat-header-cell" style="font-size: 14px;width: 180px;">
          <span translate>Students</span>
      </th>
      <th class="mat-header-cell" *ngIf="!isUHD" style="font-size: 14px;width: 180px;">
          <span translate>Status</span>
      </th>
    </tr>
    <tr class="mat-row" *ngFor="let family of families;let i = index;" style="border-width:0;border-bottom-width: 1px;border-style: solid;align-items: center;box-sizing: border-box;border-bottom-color: rgba(0,0,0,.12);">
      <td class="mat-cell" style="vertical-align: top;padding-top:10px;width: 60px;">
        <mat-radio-button [value]="family.FamilyId" id="rbFamily{{i}}" (change)="radioChange($event);">
        </mat-radio-button>
      </td>
      <td class="mat-cell" style="vertical-align: top;padding-top:10px;width: 180px;">
        {{family.ParentType | translate}}
      </td>
      <td class="mat-cell" style="vertical-align: top;padding-top:10px;width: 180px;">
        <div *ngFor="let student of family.Students" style="padding-bottom: 2px;">
          {{student.FirstName }}&nbsp;{{ student.LastName}}
        </div>
      </td>
      <td class="mat-cell" *ngIf="!isUHD" style="vertical-align: top;padding-top:10px;width: 180px;">
        {{family.Status}}
      </td>
    </tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-right">
    <error-prompt [errorList]="errors"> </error-prompt>
    <tyl-button image="save black.png" label="OK" (clickEvent)="okClick();"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
